module.exports = __webpack_public_path__ + "img/howtoplay-07.cc86c1b5.jpg";